/**
 * Brazilian Portuguese (pt-BR) mappings for MessageLimitModal
 */

export const messageLimitModalPtBR = {
  // Header
  "Long Conversation": "Conversa Longa",
  "messages in this chat": "mensagens neste chat",

  // Main message
  "This conversation has grown quite long! For better performance and organization, we recommend starting a new chat.": "Esta conversa ficou bastante longa! Para melhor desempenho e organização, recomendamos iniciar um novo chat.",

  // Benefits section
  "Benefits of starting fresh:": "Benefícios de começar do zero:",
  "Faster response times": "Respostas mais rápidas",
  "Better conversation focus": "Melhor foco na conversa",
  "Easier to find specific topics": "Mais fácil encontrar tópicos específicos",

  // Buttons
  "Continue Here": "Continuar Aqui",
  "Start New Chat": "Iniciar Novo Chat",

  // Footer
  "You can always return to this conversation later": "Você sempre pode retornar a esta conversa mais tarde"
};
